import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { firstUserErrorCode } from '@/graphql/errors';
import { REQUEST_SIGN_IN_LINK } from '@/graphql/mutations/auth';
import type { SignInLinkData } from '../types';

export type RequestSignInLinkOutcome =
  | { link: SignInLinkData; errorCode: null }
  | { link: null; errorCode: string };

type UseRequestSignInLinkResult = {
  requestSignInLink: (email: string) => Promise<RequestSignInLinkOutcome>;
  isRequesting: boolean;
};

export function useRequestSignInLink(): UseRequestSignInLinkResult {
  const [mutate, { loading }] = useMutation(REQUEST_SIGN_IN_LINK);

  const requestSignInLink = useCallback(
    async (email: string): Promise<RequestSignInLinkOutcome> => {
      const { data } = await mutate({ variables: { input: { email } } });
      const payload = data?.requestSignInLink;
      if (payload?.link) return { link: payload.link, errorCode: null };
      return { link: null, errorCode: firstUserErrorCode(payload?.userErrors) ?? 'UNKNOWN' };
    },
    [mutate],
  );

  return { requestSignInLink, isRequesting: loading };
}
